import React from 'react';
import { Outlet, Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Logo from './components/Logo';
import './LinkedInTheme.css';

const PublicLayout = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const handleLanguageCycle = () => {
    const languages = ['en-GB', 'tr-TR'];
    const currentLanguage = i18n.language;
    let currentIndex = languages.findIndex(lang => currentLanguage.startsWith(lang.substring(0, 2)));
    if (currentIndex === -1) currentIndex = 0;
    const nextIndex = (currentIndex + 1) % languages.length;
    i18n.changeLanguage(languages[nextIndex]);
  };

  return (
    <div className="li-auth-wrapper">
      {/* Public Header */}
      <header className="li-auth-header">
         <div className="li-auth-header-content">
            <Link to="/" style={{ textDecoration: 'none' }}>
                <Logo size={34} style={{ color: '#0a66c2' }} />
            </Link>
            
             <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  {/* Language Switcher */}
                  <button 
                      onClick={handleLanguageCycle}
                      style={{ border: 'none', background: 'none', color: '#666', fontSize: '14px', fontWeight: '600', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '4px', marginRight: '8px' }}
                    >
                      <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor"><circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" strokeWidth="2"></circle><path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" fill="none" stroke="currentColor" strokeWidth="2"></path></svg>
                      <span className="hide-on-mobile">{i18n.language.startsWith('tr') ? 'English' : 'Türkçe'}</span>
                  </button>

                  <Link to="/login" className="li-btn-outline-secondary" style={{ borderRadius: '24px', padding: '10px 24px', textDecoration: 'none', color: 'rgba(0,0,0,0.6)', border: '1px solid rgba(0,0,0,0.6)' }}>
                    {t('auth.signIn', 'Sign in')}
                  </Link>
                  <Link to="/login?invite_token=" className="li-btn-primary" style={{ borderRadius: '24px', padding: '10px 24px', textDecoration: 'none' }}>
                    {t('auth.joinNow', 'Join now')}
                  </Link>
             </div>
         </div>
      </header>

      {/* Main Content */}
      <main style={{ width: '100%', flex: 1, display: 'flex', flexDirection: 'column' }}>
        <Outlet />
      </main>

      {/* Footer */}
      <footer className="footer" style={{ marginTop: 'auto', padding: '24px', textAlign: 'center', fontSize: '12px', color: 'rgba(0,0,0,0.6)', width: '100%', backgroundColor: '#fff', borderTop: '1px solid #e0e0e0' }}>
         <div style={{ maxWidth: '1128px', margin: '0 auto', display: 'flex', justifyContent: 'center', gap: '24px', flexWrap: 'wrap' }}>
            <Link to="/about" style={{ color: 'rgba(0,0,0,0.6)', textDecoration: 'none' }}>{t('footer.about', 'About')}</Link>
            <Link to="/accessibility" style={{ color: 'rgba(0,0,0,0.6)', textDecoration: 'none' }}>{t('footer.accessibility', 'Accessibility')}</Link>
            <Link to="/help-center" style={{ color: 'rgba(0,0,0,0.6)', textDecoration: 'none' }}>{t('footer.helpCenter', 'Help Center')}</Link>
            <Link to="/privacy-terms" style={{ color: 'rgba(0,0,0,0.6)', textDecoration: 'none' }}>{t('footer.privacyTerms', 'Privacy & Terms')}</Link>
         </div>
         <div style={{ marginTop: '12px' }}>
            <p>{t('auth.footer.rights', '© 2025 POD+. All rights reserved.')}</p>
         </div>
      </footer>
    </div>
  );
};

export default PublicLayout;